import React, { useEffect, useState } from "react";
import { adminNewsletter, adminNotifications } from "@/lib/api";

const NewsletterAdmin = () => {
  const [subs, setSubs] = useState([]);
  const [notifs, setNotifs] = useState([]);
  useEffect(() => {
    adminNewsletter().then(setSubs).catch(() => {});
    adminNotifications().then(setNotifs).catch(() => {});
  }, []);

  return (
    <div className="grid grid-cols-1 gap-8 p-5 sm:p-8 lg:grid-cols-2" data-testid="newsletter-admin">
      <div>
        <h2 className="mb-4 text-xl uc font-semibold">Newsletter [{subs.length}]</h2>
        <div className="divide-y divide-border border-y border-border">
          {subs.map((s) => <div key={s.email} className="py-2 font-mono text-xs">{s.email}</div>)}
          {subs.length === 0 && <p className="py-3 font-mono text-xs uppercase tracking-widest text-muted-foreground">Niciun abonat.</p>}
        </div>
      </div>
      <div>
        <h2 className="mb-4 text-xl uc font-semibold">Anunță-mă în stoc [{notifs.length}]</h2>
        <div className="divide-y divide-border border-y border-border">
          {notifs.map((n, i) => <div key={i} className="flex justify-between py-2 font-mono text-xs"><span>{n.email}</span><span className="text-muted-foreground uppercase">{n.slug}</span></div>)}
          {notifs.length === 0 && <p className="py-3 font-mono text-xs uppercase tracking-widest text-muted-foreground">Nicio cerere.</p>}
        </div>
      </div>
    </div>
  );
};

export default NewsletterAdmin;
